import { listen, qs, qsa, remove, add, toggle } from '@fluorescent/dom';
import { section } from '@/glow';

import { emit } from '@/glow/events';
import { cart } from '@/glow';
import { formatMoney } from '@/glow';

const classes = {
  hide: 'hidden',
};

const selectors = {
  update: '[data-update-cart]',
  item: '.cart-template__item',
  updateInput: '[name="updates[]"]',
  quantityError: '[data-quantity-error]',
  loadingSpinner: '.cart__update-loading',
  subTotal: '.cart__subtotal',
  lineItemPrice: '.cart-template__line-price',
};

section('cart', {
  onLoad() {
    this.items = qsa(selectors.item, this.container);
    this.updateButton = qs(selectors.update, this.container);
    this.loadingSpinner = qs(selectors.loadingSpinner, this.container);
    this.events = [
      listen(this.updateButton, 'click', this.handleClick.bind(this)),
    ];
    this.subTotal = qs(selectors.subTotal, this.container);
    this.cartState = {
      currentItemCount: this.getTotalItemQuantities(),
      items: {},
    };
    // Keep all updates together to force an update a similar time outside of the
    // async fetches
    this.updates = [];

    this.items.forEach(item => {
      const { itemId } = item.dataset;
      const quantityInput = qs(selectors.updateInput, item);
      const quantity = parseInt(quantityInput.value, 10);

      this.cartState.items[itemId] = quantity;
    });
  },

  getCurrentItemCount(state) {
    return Object.keys(state.items).reduce(
      (prev, curr) => (prev += state.items[curr]),
      0
    );
  },

  getTotalItemQuantities() {
    return Array.from(qsa('[name="updates[]"]', this.container)).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
  },

  handleClick(e) {
    e.preventDefault();
    this.toggleLoader();

    const fetches = this.items.map(
      (item, index) => () => this.updateQuantity(item, index)
    );

    fetches.reduce((p, fn, i) => {
      if (i === fetches.length - 1) {
        return p.then(fn).then(() => {
          this.toggleLoader();
          this.updates.forEach(update => update());
          this.updates = [];
        });
      } else {
        return p.then(fn);
      }
    }, Promise.resolve());
  },

  updateQuantity(item, iterable) {
    const { itemId } = item.dataset;
    const quantityInput = qs(selectors.updateInput, item);
    const quantity = parseInt(quantityInput.value, 10);
    const quantityError = qs(selectors.quantityError, item);
    const price = qs(selectors.lineItemPrice, item);

    add(quantityError, classes.hide);

    const body = JSON.stringify({
      id: itemId,
      quantity,
    });

    return fetch(`${theme.routes.cart.change}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`,
      },
      ...{ body },
    })
      .then(response => {
        return response.text();
      })
      .then(state => {
        const parsedState = JSON.parse(state);
        // Find line item in cart results
        const returnedLineItem = parsedState.items.find(
          ({ id }) => id === parseInt(itemId, 10)
        );

        const newState = JSON.parse(JSON.stringify(this.cartState));

        if (newState.items[itemId] !== quantity) {
          newState.items[itemId] = quantity;
          newState.currentItemCount = this.getCurrentItemCount(newState);

          if (
            newState.currentItemCount !== parsedState.item_count &&
            newState.currentItemCount > parsedState.item_count
          ) {
            // Failed to add new item due to quantity
            remove(quantityError, classes.hide);
            quantityInput.value = returnedLineItem.quantity;
          } else {
            // Successfully updated item in cart
            this.cartState = Object.assign({}, newState);
            emit('cart:updated', { cart: cart.sortCart(parsedState) });
          }

          this.updates.push(() =>
            this.updatePrice(price, returnedLineItem.line_price)
          );
        }

        // Update the cart on the last item
        if (iterable === this.items.length - 1) {
          console.log(parsedState);
          this.updates.push(() =>
            this.updatePrice(this.subTotal, parsedState.total_price)
          );
        }
      });
  },

  updatePrice(element, price) {
    element.innerHTML = formatMoney(price);
  },

  toggleLoader() {
    toggle([this.updateButton, this.loadingSpinner], classes.hide);
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
  },
});
